// extracted by mini-css-extract-plugin
export default {"progressBox":"Balance_progressBox__zJfub","progressInner":"Balance_progressInner__VQ2L4"};